import { ExportInfos } from './../export-info';

export class ExportInfosBuilder {
    static build(exportInfosVO): ExportInfos {
        const exportInfos = new ExportInfos();
        exportInfos.id = exportInfosVO.id;
        exportInfos.fileName = exportInfosVO.fileName;
        exportInfos.debut = exportInfosVO.created;
        exportInfos.fin = exportInfosVO.completed;
        exportInfos.typeFichier = exportInfosVO.tsExportFileType;
        exportInfos.statut = exportInfosVO.status;
        return exportInfos;
    }
}



// WEBPACK FOOTER //
// ./src/app/model/builder/export-infos.builder.ts